import { Text, View } from 'react-native'
import { DENSE_TABLE_MAX_FONT_SCALE } from '../leagueDetail.constants'
import { TeamKitCell } from './TeamKitCell'
import type { StandingRow } from '../../../src/leagueDetail'
import type { LeagueStandingsTableStyles } from './LeagueStandingsTable.styles'

interface FullRowProps {
  row: StandingRow
  isLast: boolean
  styles: LeagueStandingsTableStyles
  kitSize: number
  isCompactMobile: boolean
}

export function FullRow({ row, isLast, styles, kitSize, isCompactMobile }: FullRowProps) {
  return (
    <View style={[styles.row, isLast && styles.rowLast]}>
      <View style={styles.rowLeading} />
      <View style={styles.rowInner}>
        <View style={styles.cellRank}>
          <Text style={styles.rankText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
            {row.rank}
          </Text>
        </View>
        <View style={styles.cellTeam}>
          <TeamKitCell
            displayName={row.displayName}
            countryCode={row.countryCode}
            kitPrimary={row.kitPrimary}
            kitSecondary={row.kitSecondary}
            kitType={row.kitType}
            styles={styles}
            kitSize={kitSize}
          />
          <Text style={styles.teamName} numberOfLines={2} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
            {row.displayName}
          </Text>
        </View>
        <View style={styles.cellStatSym}>
          <Text style={styles.cellStatSymText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.played}</Text>
        </View>
        <View style={styles.cellStatSym}>
          <Text style={styles.cellStatSymText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.won}</Text>
        </View>
        <View style={styles.cellStatSym}>
          <Text style={styles.cellStatSymText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.drawn}</Text>
        </View>
        <View style={styles.cellStatSym}>
          <Text style={styles.cellStatSymText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.lost}</Text>
        </View>
        {!isCompactMobile && (
          <View style={styles.cellStatSym}>
            <Text style={styles.cellStatSymText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.goalsFor}</Text>
          </View>
        )}
        {!isCompactMobile && (
          <View style={styles.cellStatSym}>
            <Text style={styles.cellStatSymText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.goalsAgainst}</Text>
          </View>
        )}
        <View style={styles.cellStatSym}>
          <Text style={styles.cellStatSymText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
            {row.goalDiff > 0 ? `+${row.goalDiff}` : String(row.goalDiff)}
          </Text>
        </View>
        <View style={styles.cellPts}>
          <Text style={styles.ptsText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.points}</Text>
        </View>
      </View>
    </View>
  )
}
